import { useSelector } from 'react-redux';

const preferencesField = 'mercuryPreferences';
const DENY_MANUAL_EXTRA_COST = 'denyManualExtraCost';
const DENY_MANUAL_EXTRA_BONUS = 'denyManualBonus';
const ADVANCE_JOURNEY_ALLOW_TO_SET_TIME = 'advanceJourneyAllowToSetTime';
const ALLOW_VALIDATE_PAYMENT_METHOD = 'allowValidatePaymentMethod';
const PREBOOKING_TAB_ENABLED = 'prebookingTabEnabled';
const FLEET_TAB_ENABLED = 'fleetTabEnabled';
const DONT_APPLY_SHIPPER_VALIDATION = 'dontApplyShipperValidation';
const DISPATCHING_TAB_ENABLED = 'dispatchingTabEnabled';
const FLEET_PROCESS_HIDE_QUEUED_ORDERS = 'fleetProcessHideQueuedOrders';
const ALLOW_STATE_UPDATE = 'allowStateUpdate';
const ALLOW_FREEZE_JOBS = 'allowFreezeJobs';

const preferencesMap = {
  [preferencesField]: {
    [DENY_MANUAL_EXTRA_COST]: false,
    [DENY_MANUAL_EXTRA_BONUS]: false,
    [ADVANCE_JOURNEY_ALLOW_TO_SET_TIME]: false,
    [ALLOW_VALIDATE_PAYMENT_METHOD]: false,
    [PREBOOKING_TAB_ENABLED]: false,
    [FLEET_TAB_ENABLED]: false,
    [DONT_APPLY_SHIPPER_VALIDATION]: false,
    [DISPATCHING_TAB_ENABLED]: false,
    [FLEET_PROCESS_HIDE_QUEUED_ORDERS]: false,
    [ALLOW_STATE_UPDATE]: false,
    [ALLOW_FREEZE_JOBS]: false,
  },
};

const t = {
  [DENY_MANUAL_EXTRA_COST]: {
    title: 'Deny manual extra cost',
    description: 'Deny the user to add/modify the extra cost manually.',
  },
  [DENY_MANUAL_EXTRA_BONUS]: {
    title: 'Deny manual bonus',
    description: 'Deny the user to add/modify the bonus extra manually.',
  },
  [ADVANCE_JOURNEY_ALLOW_TO_SET_TIME]: {
    title: 'Allow to set time in journey advance',
    description:
      'Gives the user the option to set an specific time when he advances the status of the journey.',
  },
  [ALLOW_VALIDATE_PAYMENT_METHOD]: {
    title: 'Allow to validate shipper payment method',
    description: 'Show payment validation field in shipper edit modal.',
  },
  [PREBOOKING_TAB_ENABLED]: {
    title: 'Enable Prebooking tab',
    description: 'This section allows to create prebookings based on the forecast',
  },
  [FLEET_TAB_ENABLED]: {
    title: 'Enable Fleet tab',
    description: 'This section group all the new processes of Fleet team',
  },
  [DONT_APPLY_SHIPPER_VALIDATION]: {
    title: 'Dont apply shipper validation creating orders',
    description:
      'Allows the user to avoid the validation that checks if a shipper payment method is validated',
  },
  [DISPATCHING_TAB_ENABLED]: {
    title: 'Enable dispatching tab inside the Fleet tab',
    description:
      'This will enable the dispatching tab inside the Fleet tab. This setting should be removed in the moment we enable for all the users.',
  },
  [FLEET_PROCESS_HIDE_QUEUED_ORDERS]: {
    title: '[Fleet Process] - Hide Queued Orders tab',
    description:
      'This will hide Queued Orders tab and will disable the main actions in the Queued Orders detail',
  },
  [ALLOW_STATE_UPDATE]: {
    title: 'Allow to update states',
    description: 'Allow the user to change the vehicle/carrier/driver state',
  },
  [ALLOW_FREEZE_JOBS]: {
    title: 'Allow to freeze journeys',
    description: 'Allow the user to freeze journeys for billing purposes.',
  },
};

const getMe = (state) => state.me;

function isPreferencePresent(me, feature) {
  if (!me) {
    return false;
  }

  const { preferences: { [preferencesField]: mercuryPreferences = {} } = {} } = me;

  return !!mercuryPreferences[feature];
}

function featurePreferenceToggle(feature) {
  //eslint-disable-next-line
  const me = useSelector((state) => getMe(state));

  if (!feature) {
    console.error('[featurePreferenceToggle] No feature provided');
    return false;
  }

  if (!me) {
    return false;
  }

  return isPreferencePresent(me, feature);
}

export {
  preferencesField,
  t,
  preferencesMap,
  featurePreferenceToggle,
  isPreferencePresent,
  DENY_MANUAL_EXTRA_COST,
  DENY_MANUAL_EXTRA_BONUS,
  ADVANCE_JOURNEY_ALLOW_TO_SET_TIME,
  ALLOW_VALIDATE_PAYMENT_METHOD,
  PREBOOKING_TAB_ENABLED,
  FLEET_TAB_ENABLED,
  DONT_APPLY_SHIPPER_VALIDATION,
  DISPATCHING_TAB_ENABLED,
  FLEET_PROCESS_HIDE_QUEUED_ORDERS,
  ALLOW_STATE_UPDATE,
  ALLOW_FREEZE_JOBS,
};
